import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { defaultTheme } from '../styles/theme/defaultTheme';

import isPropValid from '@emotion/is-prop-valid';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.css';
import { useApplyCouponFromUrl } from '@/hooks/useApplyCouponFromUrl';

// Componente para montar o hook dentro do QueryClientProvider
const CouponUrlHandler = () => {
    useApplyCouponFromUrl();
    return null;
};
import AuthModal from '../templates/AuthModal';
import { ModalPark } from '../templates/ModalPark';
import { ModalShopping } from '../templates/ModalShopping';
import { ModalPaymentPix } from '../templates/ModalPaymentPix';
import { ModalPaymentCard } from '../templates/ModalPaymentCard';
import { ModalPaymentFinished } from '../templates/ModalPaymentFinished';
import { ModalAddress } from '../templates/ModalAddress';
import { GiftsModal } from '@/templates/GiftsModal';
import { FaqModal } from '@/templates/FaqModal';
import { RemovingElementModal } from '../components/ModalRemovingElement';
import { ImageBanner } from '../components/ImageBanner';
import { useBannerStore } from '../store/ui/bannerStore';

// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
        },
    },
});

declare global {
    interface Window {
        queryClient: QueryClient;
    }
}

window.queryClient = queryClient;

export const Providers = ({ children }: { children: React.ReactNode }) => {
    const { isVisible: bannerVisible, imageSrc: bannerImageSrc, alt: bannerAlt } = useBannerStore();

    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <QueryClientProvider client={queryClient}>
                <StyleSheetManager
                    enableVendorPrefixes
                    shouldForwardProp={(propName, elementToBeRendered) => {
                        return typeof elementToBeRendered === 'string'
                            ? isPropValid(propName)
                            : true;
                    }}
                >
                    <ThemeProvider theme={defaultTheme}>
                        {/* monta o hook global para aplicar cupom via URL/hash */}
                        <CouponUrlHandler />
                        {children}
                        <ModalShopping />
                        <ModalPark />
                        {/* <ModalServices /> */}
                        <RemovingElementModal />
                        <ModalPaymentPix />
                        <ModalPaymentCard />
                        <ModalPaymentFinished />
                        <ModalAddress />
                        <AuthModal />
                        <GiftsModal />
                        <FaqModal />
                        {bannerImageSrc && (
                            <ImageBanner
                                isVisible={bannerVisible}
                                setVisible={(v: boolean) => useBannerStore.getState().setVisible(v)}
                                imageSrc={bannerImageSrc}
                                alt={bannerAlt ?? 'banner'}
                            />
                        )}
                    </ThemeProvider>
                    <ToastContainer
                        closeOnClick
                        style={{
                            fontSize: '1rem',
                            fontWeight: '400',
                            // visibility: "hidden"
                        }}
                        position="top-right"
                        autoClose={5000}
                    />
                </StyleSheetManager>
            </QueryClientProvider>
        </BrowserRouter>
    );
};
